import { makeStyles, tokens } from '@fluentui/react-components';

export const useNavSectionStyles = makeStyles({
  navGroup: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '0.125rem',
  },
  navGroupLabel: {
    paddingLeft: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalXS,
    fontSize: tokens.fontSizeBase100,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    borderRadius: tokens.borderRadiusMedium,
    textDecoration: 'none',
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase300,
    transitionProperty: 'background',
    transitionDuration: '0.1s',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
      color: tokens.colorNeutralForeground1,
    },
  },
  navItemActive: {
    backgroundColor: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground1,
    fontWeight: tokens.fontWeightSemibold,
    ':hover': { backgroundColor: tokens.colorBrandBackground2Hover },
  },
  navItemIcon: {
    flexShrink: '0',
    display: 'flex',
    alignItems: 'center',
  },
  navItemLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});
